import { ArrowRightIcon } from "@mui/x-date-pickers";
import classNames from "classnames";
import type { ReactNode } from "react";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import i18n from "../../../../../../services/i18n";
import { removeLeadingSlash } from "../../../../helpers";
import styles from "./styles.module.css";

interface Props {
  activeIndex: number | null;
  availableLinks: string[];
  handleOpenMenu: (
    event: React.MouseEvent<HTMLElement>,
    link: string,
    index: number,
  ) => void;
  handleCloseMenu: () => void;
  children: ReactNode;
}

export const AvailableServiceLinks = ({
  activeIndex,
  availableLinks,
  handleOpenMenu,
  handleCloseMenu,
  children,
}: Props) => {
  const { t } = useTranslation();

  const sortedAvailableLinks = useMemo(() => {
    return [...availableLinks]
      .sort((a, b) => {
        const nameA = t(`header.${removeLeadingSlash(a)}`);
        const nameB = t(`header.${removeLeadingSlash(b)}`);
        return nameA.localeCompare(nameB);
      })
      .filter((link) => link !== "/default");
  }, [availableLinks, t, i18n.language]);
  return (
    <div className={styles["available-links-container"]}>
      <ul className={styles["available-link-list"]}>
        {sortedAvailableLinks.map((link, index) => (
          <li
            key={`${link}-${index}`}
            onMouseEnter={(e) => handleOpenMenu(e, link, index)}
            onMouseLeave={handleCloseMenu}
            className={classNames(
              styles["available-link-item"],
              activeIndex === index && styles.active,
            )}
          >
            <span>{t(`header.${removeLeadingSlash(link)}`)}</span>
            <ArrowRightIcon />
            {activeIndex === index && children}
          </li>
        ))}
      </ul>
    </div>
  );
};
